import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../../ui/Popover";
import { ActionDotsBlack, CrownIcon } from "../../../icons";
import { AddDriverDashboardModal } from "../addDriverDashboardModal";
import { RetailDriverActionButton } from "../../ui/retailDriverActionButton";

export const RetailDriver = ({ driver, handleClickAction, carInfo}) => {
    const [openPopover, setOpenPopover] = useState(false);
    const [openDialogAssign, setOpenDialogAssign] = useState(false);
    const [openDialogPrimary, setOpenDialogPrimary] = useState(false);
    const [openDialogDeletion, setOpenDialogDeletion] = useState(false);

    return (
      <div className="w-full gap-4 flex justify-between items-center">
        {/* <div className="xl:hidden 2xl:block rounded-full w-10 h-10 bg-[#6A6A6A]"/> */}
        <div className="min-w-0 flex-1">
          <h6 className="truncate">

            {driver.firstName} {driver.lastName}
          </h6>
          <p className="text-disclaimer">
            {driver.isPrimary ? 'Κύριος οδηγός' : 'Οδηγός'}
          </p>
        </div>
        <div className="shrink-0">
          {driver?.isPrimary ? <CrownIcon /> : <Popover
            open={openPopover}
            onOpenChange={(open) => {
              setOpenPopover(open);
            }}
          >
            <PopoverTrigger className="mb-4">
              <ActionDotsBlack
                className={
                  openPopover
                    ? 'bg-black stroke-white rounded-full'
                    : 'stroke-black cursor-pointer'
                }
              />
            </PopoverTrigger>
            <PopoverContent
              style={{ padding: 0 }}
              className={'text-body rounded-[8px] flex flex-col items-center'}
            >
              <AddDriverDashboardModal
                mode={'edit'}
                driversDetails={driver}
                plateno={carInfo.plateno}
              />
              <div>
                <RetailDriverActionButton
                  className={'p-4 cursor-pointer'}
                  title="Αφαίρεση"
                  content={
                    <div className="flex flex-col gap-6">
                      <h3 className="text-center">Αφαίρεση Οδηγού</h3>
                      <div className="text-body">
                        Είσαι σίγουρος ότι θέλεις να αφαιρέσεις τον/την
                        <span className="font-[700]">
                          {' '}
                          {driver.firstName} {driver.lastName}
                        </span>
                      </div>
                    </div>
                  }
                  openModal={openDialogAssign}
                  setOpenModal={setOpenDialogAssign}
                  handleOkClick={async () => {
                    handleClickAction('unAssignDriver', driver.id);
                    setOpenPopover(false)
                    setOpenDialogAssign(false);
                  }}
                />
              </div>
              {!driver.isPrimary && (
                <div>
                  <RetailDriverActionButton
                    className={'p-4 cursor-pointer'}
                    title="Ορισμός ως κύριος οδηγός"
                    content={
                      <div className="flex flex-col gap-6">
                        <h3 className="text-center">Ορισμός ως κύριος οδηγός</h3>
                        <div className="text-body">
                          Είσαι σίγουρος ότι θέλεις να ορίσεις τον/την{' '}
                          <b>
                            
                            {driver.firstName} {driver.lastName}{' '}
                          </b>
                          ως κύριο οδηγό;
                        </div>
                      </div>
                    }
                    openModal={openDialogPrimary}
                    setOpenModal={setOpenDialogPrimary}
                    handleOkClick={() => {
                      handleClickAction('setPrimaryDriver', driver.id);
                      setOpenPopover(false)
                      setOpenDialogPrimary(false);
                    }}
                  />
                </div>
              )}
                <RetailDriverActionButton
                  className={
                    'p-4 bg-[#F5F5F7] text-[#D4002A] cursor-pointer rounded-b-[8px] w-full'
                  }
                  title="Διαγραφή"
                  content={
                    <div className="flex flex-col gap-6 text-center">
                      <h3 className="text-center">Διαγραφή οδηγού</h3>
                      <div className="text-body text-center">
                        Είσαι σίγουρος ότι θέλεις να διαγράψεις οριστικά τον/την{' '}
                        <b>
                          {' '}
                          {driver.firstName} {driver.lastName}{' '}
                        </b>{' '}
                        από τη συνολική λίστα οδηγών;
                      </div>
                      <div className="text-body">
                        Αυτή η ενέργεια δεν μπορεί να αναιρεθεί. Για να προστεθεί
                        ξανά ως οδηγός, θα πρέπει να καταχωρίσεις εκ νέου όλα τα
                        στοιχεία.
                      </div>
                    </div>
                  }
                  openModal={openDialogDeletion}
                  setOpenModal={setOpenDialogDeletion}
                  handleOkClick={() => {
                    handleClickAction('deleteDriver', driver.id);
                    setOpenPopover(false)
                    setOpenDialogDeletion(false);
                  }}
                />
            </PopoverContent>
          </Popover>}
        </div>
      </div>
    );
  };